import {
  COMORBIDITIES_OPTIONS,
  COMPLEX_COMORBIDITIES_OPTIONS,
  CONTRACEPCAO,
} from '@/components/AttendanceForm/general/constants/personalHistory'
import {
  PROFESSIONAL_OPTIONS,
  PSYCHIATRIC_ANSWER_VALUES,
} from '@/components/AttendanceForm/general/constants/psychiatricScreening'
import { AttendanceConfig } from './AttendanceConfig'

export default new AttendanceConfig()
  .addStep('Anamnese')
  .addPhase('dados_especificos', 'Dados específicos', null)
  .addPhase('investigacao_pessoal', 'Investigação pessoal', null)
  .addPhase('antecedentes_familiares', 'Antecedentes familiares', null)
  .addPhase('triagem_psiquiatrica', 'Triagem psiquiátrica', null)
  .addStep('Exame físico')
  .addPhase('dados', 'Dados', null)
  .addPhase('imagens', 'Imagens', null)
  .addPhase('exames', 'Exames', null)
  .addStep('Resultados')
  .addPhase('resultado', 'Resultado', null)

export function generatePersonalHistoryOverview(data, attendance) {
  if (!data) {
    return []
  }

  const paragraphs = []

  const diseases = (data.diseases || [])
    .filter((key) => key !== 'outras_comorbidades')

    .map(
      (key) =>
        COMORBIDITIES_OPTIONS.find((comorbidity) => comorbidity.key === key) ||
        COMPLEX_COMORBIDITIES_OPTIONS.find((comorbidity) => comorbidity.key === key),
    )

  if (diseases.length > 0) {
    paragraphs.push(
      `<b>Apresenta as seguintes comorbidades:</b> ${diseases.map((disease) => disease?.name).join(', ')}.`,
    )
  }
  if ((data.otherDisease || '').trim()) {
    paragraphs.push(`<b>Outras:</b> ${data.otherDisease.trim()}.`)
  }

  if ((data.medicine || '').trim()) {
    paragraphs.push(`<b>Medicamentos em uso:</b> ${data.medicine.trim()}.`)
  }

  if (data.profile) {
    if (data.profile['cancer_pele']?.value) {
      let text = '<b>Câncer de pele:</b>'
      const cancerSubtype = data.profile['tipo_cancer_pele']?.value
      if (cancerSubtype) {
        text += ` Sim. (${cancerSubtype.toLowerCase()})`
      } else {
        text += ` Sim. (subtipo desconhecido)`
      }
      paragraphs.push(`${text}.`)
    } else {
      paragraphs.push('<b>Câncer de pele:</b> Não.')
    }

    if (data.profile['tabagista']?.value) {
      paragraphs.push(`<b>É tabagista:</b>  ${data.profile['tabagista'].value ? 'Sim.' : 'Não'}`)
    }
    if (data.profile['etilista']?.value) {
      paragraphs.push(`<b>É etilista:</b> ${data.profile['etilista'].value ? 'Sim.' : 'Não'}`)
    }
    if (data.profile['tuberculose']?.value) {
      paragraphs.push(`<b>Já teve tuberculose:</b> ${data.profile['etilista'].value ? 'Sim.' : 'Não'}`)
    }
    if (data.profile['tuberculose_latente']?.value) {
      paragraphs.push(
        `<b>Já tratou tuberculose latente, teve exposição prévia ou trabalha exposto a pessoas com possível tuberculose ativa:</b> ${
          data.profile['tuberculose_latente'].value ? 'Sim.' : 'Não.'
        }`,
      )
    }
    if (data.profile['tratou_tuberculose']?.value) {
      paragraphs.push(
        `<b>Tratou tuberculose doença ou tuberculose latente:</b> ${
          data.profile['tratou_tuberculose'].value ? 'Sim.' : 'Não.'
        }`,
      )
    }

    if (data.profile['drogas_ilicitas']?.value) {
      paragraphs.push(`<b>Usa drogas ilícita?</b> ${data.profile['drogas_ilicitas']?.value ? 'Sim.' : 'Não.'}`)
    }

    if (data?.profile['contracepcao']?.value) {
      paragraphs.push(`<b>Contracepção:</b>  ${data.profile['contracepcao']?.value ? 'Sim.' : 'Não.'}`)
    }

    if (data.profile['diarreia_cronica']?.value) {
      paragraphs.push(
        `<b>Tem diarreia crônica, dor abdominal ou outras alterações de hábito intestinal.</b> ${
          data.profile['diarreia_cronica'].value ? 'Sim.' : 'Não.'
        }`,
      )
    }

    if (data.profile['uveite']?.value) {
      paragraphs.push(
        `<b>Tem olhos vermelhos, fotofobia, lacrimejamento ou outras alterações visuais (uveíte)</b> ${
          data.profile['uveite'].value ? 'Sim.' : 'Não.'
        }`,
      )
    }

    if (data.profile['gravidez']?.value) {
      paragraphs.push(
        `<b>Está grávida ou pretende engravidar durante o tratamento?</b> ${
          data.profile['gravidez'].value ? 'Sim.' : 'Não.'
        }`,
      )
    }

    if (data.profile['contracepcao']?.value) {
      paragraphs.push(`<b>Métodos Contraceptivos:</b> ${data.profile['contracepcao']?.value ? 'SIM' : 'NÃO'}`)
    }

    if (data.profile['contracepcao']?.selected) {
      const birthcontrolOptions = data.profile['contracepcao'].selected.map(
        (key) => CONTRACEPCAO.find((birthcontrol) => birthcontrol.key === key).name,
      )

      birthcontrolOptions.join(',  ')

      paragraphs.push(`<b>Métodos Contraceptivos:</b> ${birthcontrolOptions}`)
    }

    if (data.profile['menarca']?.age) {
      paragraphs.push(`<b>Menarca com quantos anos?</b> ${data.profile['menarca'].age}`)
    }
  }

  paragraphs.push(...generateNotesOverview(data, attendance))

  return paragraphs
}

export function generateFamilyHistoryOverview(data, attendance) {
  if (!data) {
    return []
  }
  const paragraphs = []

  if (data.familyAtopias?.asma?.selected) {
    paragraphs.push(`<b>Asma na família:</b> ${data.familyAtopias.asma.selected ? 'Sim' : 'Não'}`)
    if (data.familyAtopias.asma.degree.length > 0) {
      paragraphs.push(
        `<b>Grau de parentesco:</b> ${data.familyAtopias.asma.degree.map((degree) => degree + ' grau').join(', ')}`,
      )
    }
  }

  if (data.familyAtopias?.rinite_alergica?.selected) {
    paragraphs.push(`<b>Rinite Alérgica na família:</b> ${data.familyAtopias.rinite_alergica.selected ? 'Sim' : 'Não'}`)
    if (data.familyAtopias.rinite_alergica.degree.length > 0) {
      paragraphs.push(
        `<b>Grau de parentesco:</b> ${data.familyAtopias.rinite_alergica.degree
          .map((degree) => degree + ' grau')
          .join(', ')}`,
      )
    }
  }

  if (data.familyAtopias?.dermatite_atopica?.selected) {
    paragraphs.push(
      `<b>Dermatite Atopica na família:</b> ${data.familyAtopias.dermatite_atopica.selected ? 'Sim' : 'Não'}`,
    )
    if (data.familyAtopias.dermatite_atopica.degree.length > 0) {
      paragraphs.push(
        `<b>Grau de parentesco:</b> ${data.familyAtopias.dermatite_atopica.degree
          .map((degree) => degree + ' grau')
          .join(', ')}`,
      )
    }
  }

  if (data.familyAtopias?.psoriase?.selected) {
    paragraphs.push(`<b>Psoríase na família:</b> ${data.familyAtopias.psoriase.selected ? 'Sim' : 'Não'}`)
    if (data.familyAtopias.psoriase.degree.length > 0) {
      paragraphs.push(
        `<b>Grau de parentesco:</b> ${data.familyAtopias.psoriase.degree.map((degree) => degree + ' grau').join(', ')}`,
      )
    }
  }
  // if (data.profile) {
  //   if (data.profile['doenca_reumatologia']?.value) {
  //     paragraphs.push(
  //       `<b>Alguém na família tem doença reumatológica (reumatismo, artrite, doença auto-imune):</b> ${
  //         data.profile['doenca_reumatologia'].value ? 'Sim' : 'Não'
  //       }`,
  //     )
  //     if (data.profile['doenca_reumatologia'].complement) {
  //       paragraphs.push(`<b>Doença informada:</b> ${data.profile['doenca_reumatologia'].complement}`)
  //     }
  //     if (data.profile['doenca_reumatologia'].degree) {
  //       paragraphs.push(`<b>Grau de parentesco:</b> ${data.profile['doenca_reumatologia'].degree}`)
  //     }
  //   }

  //   if (data.profile['esclerose_multipla']?.value) {
  //     paragraphs.push(
  //       `<b>Alguém na família tem esclerose mútlipla:</b> ${data.profile['esclerose_multipla'].value ? 'Sim' : 'Não'}`,
  //     )
  //     if (data.profile['esclerose_multipla'].complement) {
  //       paragraphs.push(`<b>Doença informada:</b> ${data.profile['esclerose_multipla'].complement}`)
  //     }
  //     if (data.profile['esclerose_multipla'].degree) {
  //       paragraphs.push(`<b>Grau de parentesco:</b> ${data.profile['esclerose_multipla'].degree}`)
  //     }
  //   }

  //   if (data.profile['cancer_familia']?.value) {
  //     paragraphs.push(
  //       `<b>Algum histórico de câncer na família:</b> ${data.profile['cancer_familia'].value ? 'Sim' : 'Não'}`,
  //     )
  //     if (data.profile['cancer_familia'].complement) {
  //       paragraphs.push(`<b>Doença informada:</b> ${data.profile['cancer_familia'].complement}`)
  //     }
  //     if (data.profile['cancer_familia'].degree) {
  //       paragraphs.push(`<b>Grau de parentesco:</b> ${data.profile['cancer_familia'].degree}`)
  //     }
  //   }
  // }
  paragraphs.push(...generateNotesOverview(data, attendance))

  return paragraphs
}

export function generatePsychiatricScreenOverview(data, attendance) {
  if (!data) {
    return []
  }
  const paragraphs = []

  const anxietyFirstAnswer = data.profile['nervoso_ansioso_limite_duas_ultimas_semanas']?.value || 'NUNCA'

  const anxietySecondAnswer = data.profile['incapaz_controlar_preocupacoes_duas_ultimas_semanas']?.value || 'NUNCA'

  const anxietyScore = PSYCHIATRIC_ANSWER_VALUES[anxietyFirstAnswer] + PSYCHIATRIC_ANSWER_VALUES[anxietySecondAnswer]

  const depressionFirstAnswer = data.profile['pouco_interesse_prazer_duas_ultimas_semanas']?.value || 'NUNCA'

  const depressionSecondAnswer = data?.profile['deprimido_duas_ultimas_semanas']?.value || 'NUNCA'

  const depressionScore =
    PSYCHIATRIC_ANSWER_VALUES[depressionFirstAnswer] + PSYCHIATRIC_ANSWER_VALUES[depressionSecondAnswer]

  paragraphs.push(`O paciente tem Ansiedade/Depressão? ${data.anxiety_depression?.anxiety_depression.value}`)
  paragraphs.push(`Faz acompanhamento? ${data.anxiety_depression?.attendance.value ? `Sim` : `Não`}`)

  if (data.anxiety_depression?.attendance.value) {
    if (data.anxiety_depression?.attendance.selected.length > 0 || data.anxiety_depression?.attendance.other) {
      paragraphs.push(
        `Profissional: ${data.anxiety_depression?.attendance.selected
          .filter((professional) => professional !== 'outro')
          .map((keys) => PROFESSIONAL_OPTIONS.find((option) => option.value === keys).text)
          .join(', ')}${
          data.anxiety_depression?.attendance.other ? ', ' + data.anxiety_depression?.attendance.other : ''
        }
        `,
      )
    } else {
      paragraphs.push('Profissional: Não informado')
    }
  }

  if (data.anxiety_depression?.support_group) {
    paragraphs.push(`Participa de algum grupo de apoio? ${data.anxiety_depression.support_group.value ? 'Sim' : 'Não'}`)
  }

  paragraphs.push(`Triagem Ansiedade: ${anxietyScore >= 2 ? 'Suspeito' : 'Não suspeito'}`)
  paragraphs.push(`Triagem Depressão: ${depressionScore >= 2 ? 'Suspeito' : 'Não suspeito'}`)

  paragraphs.push(...generateNotesOverview(data, attendance))

  return paragraphs
}

export function generateNotesOverview(data, attendance) {
  if (data?.notes) {
    return data.notes.split(/\n/)
  }

  return []
}
